import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 考核新增
  recordPageList(params) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_record/recordPageList`,
      method: 'get',
      params,
    });
  },
  // 考核导出
  recordExcelExport(params) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_record/recordExcelExport`,
      method: 'get',
      params,
    });
  },
  // 单条补发证书
  grantCertificate(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_record/grantCertificate`,
      method: 'post',
      data,
    });
  },
  // 一键批量颁发本场考核所有合格者证书
  batchGrantCertificate(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_record/batchGrantCertificate`,
      method: 'post',
      data,
    });
  },
  // 考核成绩统计（参考人数/通过率/平均分/分数段分布）
  examStatistics(params) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_record/examStatistics`,
      method: 'get',
      params,
    });
  },
};
